import { autoserialize, autoserializeAs } from 'cerialize';
import { FareAdjustment } from './fare-adjustment';

export class FareReviewStatusUpdate {
  @autoserialize
  reservationId: number;

  @autoserialize
  status: string;

  @autoserializeAs(FareAdjustment)
  fareAdjustment: FareAdjustment;
}
